import React, { useMemo, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { tableHeader2, columns } from "../NetPositions/FnOUtility";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import exportToPDF from "../../Components/Common/exportToPDF";
import { showToast } from "../../Components/ToastNotification";
import { formatDateDay, getCurrentFiscalYearDates, getPreviousMonthWorkingDates } from "../../Components/Common/WorkingDateRange";

const Transaction_Ledger_Pdf = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const { userData } = usePersistStoreData();

  const getPreviousMonth = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1); // Get previous month
    return date.toLocaleString("en-US", { month: "long" }).toUpperCase(); // Convert to uppercase
  };

  const now = new Date();

  // Get the first day of the previous month (1st of last month)
  const start_date = new Date(now.getFullYear(), now.getMonth() - 1, 1);

  // Get the last day of the previous month
  const end_date = new Date(now.getFullYear(), now.getMonth(), 0); // 0th day of current month

  // Format the date as "YYYY-MM-DD"
  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`; // Changed order here
  };

  const { fyStart } = getCurrentFiscalYearDates();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
      const endDate = today;

  const columns = useMemo(
    () => [
      {
        id: "transaction_date_formatted",
        Header: "Fin. Date",
        accessorKey: "transaction_date_formatted",
      },
      { id: "scrip_name", Header: "Particulars", accessorKey: "scrip_name" },
      {
        id: "delv_settlement_no",
        Header: "Delv. Sett. No.",
        accessorKey: "delv_settlement_no",
        headerTextAlign: "start",
        bodyTextAlign: "start",
      },
      {
        id: "buy_qty",
        Header: "Buy Qty.",
        accessorKey: "buy_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "sell_qty",
        Header: "Sell Qty.",
        accessorKey: "sell_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "market_rate",
        Header: "Mkt. Rate (₹)",
        accessorKey: "market_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "net_rate",
        Header: "Net. Rate (₹)",
        accessorKey: "net_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "debit",
        Header: "Debit (₹)",
        accessorKey: "debit",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "credit",
        Header: "Credit (₹)",
        accessorKey: "credit",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "cumulative_qty",
        Header: "Cumlv. Qty.",
        accessorKey: "cumulative_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "cumulative_balance",
        Header: "Cumlv. Bal. (₹)",
        accessorKey: "cumulative_balance",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
    ],
    []
  );

  const handleExport = async () => {
     // Determine the previous month from today's date.
     const today = new Date();
     // JavaScript month indexes: 0=January, 1=February, 2=March, etc.
     const prevMonth = today.getMonth() === 0 ? 11 : today.getMonth() - 1;

     // If the previous month is March (index 2), show error and do not call the API.
     if (prevMonth === 2) {
       showToast("No report is available for previous month of current FY", "error");
       return;
     }
    try {
      setLoading(true);

      // const { startDate, endDate } = getPreviousMonthWorkingDates();
      // First fetch the data

      const response = await axios.get("transaction-ledger", {
        params: {
          start_date: formatDate(fyStart),
          end_date: formatDate(endDate),
        },
        headers: {
          Authorization: `Bearer ${userData?.token}`,
          "Content-Type": "application/json",
        },
      });

      const summary = response?.data?.summary;
      const rawItems = response?.data?.items;

      const data = Object.values(rawItems).flatMap(
        (arr) => arr.filter((entry) => !entry.group_summary) // exclude group_summary rows
      );

      const tableHeaders = columns.map((col) => col.Header.replace(/₹/g, "Rs"));

      const tableBody = data?.map((row) =>
        columns.map((col) =>
          row[col.accessorKey]
            ? typeof row[col.accessorKey] === "string"
              ? row[col.accessorKey]
              : row[col.accessorKey].toLocaleString("en-IN")
            : 0
        )
      );

      // Define which columns to sum
      const sumColumns = ["debit", "credit", "cumulative_balance"];
      const apiTotals = {
        debit: summary?.debit,
        credit: summary?.credit,
        cumulative_balance: summary?.cumulative_balance,
      };

      // Calculate totals only for "debit" and "credit"
      const totals = columns.map((col, index) => {
        if (index === 0) return "TOTAL"; // First column will have "Total"

        return sumColumns.includes(col.accessorKey)
          ? apiTotals[col.accessorKey]?.toLocaleString("en-IN") || 0 // Use API total, default to 0 if missing
          : ""; // Leave other columns empty
      });

      // Add totals row to the table
      tableBody.push(totals);

      // Use the response data directly for the PDF export instead of relying on state
      exportToPDF(
        "Transaction Ledger",
        userData,
        ``,
        `From: ${formatDateDay(fyStart)} - To: ${formatDateDay(endDate)}`,
        tableHeaders,
        tableBody
      );
    } catch (error) {
      console.error("Failed to export PDF due to API error", error);
      showToast("Something went wrong please try again", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="d-flex border-bottom mt-3"
        style={{ cursor: "pointer" }}
        onClick={handleExport}
      >
        <div className="d-flex align-items-center justify-content-between mb-2 w-100">
          <div className="d-flex flex-column">
            <h6 className="text-primary fw-semibold fs-14">
              {getPreviousMonth()} - Transaction Ledger Report
            </h6>
            <div className="d-flex">
              <p className="fs-14 fw-medium text-muted me-2 mb-1 m-0 text-decoration-underline">
                {loading ? "Downloading..." : "Download"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Transaction_Ledger_Pdf;
